//
// ContainerController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./PositionedModelOwnerController";
import "../../models/view/layout/Container";
import "../visualElements/VisualContainerElementController";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "./ContainerType";

var ContainerController = createModule("BIRD::ContainerController", ["BIRD::BIRDModelController","BIRD::PositionedModelController","BIRD::PositionedModelOwnerController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getVisualContainerElementController: [1],
        getModel: [1],
        getStackNavigationStyleChain: [1],
        getContentOffset: [11],
        getContainerType: [4],
        getContainerBackgroundStyleChain: [1],
        getSpanStyleChain: [1,1,1],
        setContentOffset: [0,11],
        hideTooltip: [0],
        isCompositeContainer: [2],
        getHorizontalTitlePadding: [5],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default ContainerController;
